import React, { ReactNode } from "react";
import './TitleActive.scss';

export const TitleActive = ({
  children
}: {
  children: ReactNode
}) => (<h4 className="title">{children}</h4>);